/* ══════════════════════════════════════
   BANDWERK — LIMITED EDITION PAGE JS
   ══════════════════════════════════════ */

(function () {
  'use strict';

  /* ── COUNTDOWN ── */
  function initCountdown() {
    var el = document.querySelector('[data-le-countdown]');
    if (!el) return;

    var targetDate = el.getAttribute('data-le-countdown');
    if (!targetDate) return;

    var target = new Date(targetDate);
    var dEl = el.querySelector('[data-le-cd-d]');
    var hEl = el.querySelector('[data-le-cd-h]');
    var mEl = el.querySelector('[data-le-cd-m]');
    var sEl = el.querySelector('[data-le-cd-s]');

    function tick() {
      var diff = target - new Date();
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        return;
      }
      if (dEl) dEl.textContent = String(Math.floor(diff / 86400000)).padStart(2, '0');
      if (hEl) hEl.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
      if (mEl) mEl.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      if (sEl) sEl.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── CATEGORY SWITCHER ── */
  function initCategorySwitcher() {
    var panels = document.querySelectorAll('[data-le-panel]');
    var catBtns = document.querySelectorAll('[data-le-cat-btn]');
    var swBtns = document.querySelectorAll('[data-le-sw-btn]');
    var cards = document.querySelectorAll('[data-le-card-category]');

    function switchCategory(cat) {
      panels.forEach(function (panel) {
        var panelCat = panel.getAttribute('data-le-panel');
        if (panelCat === cat) {
          panel.classList.add('is-active');
          panel.classList.remove('is-inactive');
        } else {
          panel.classList.add('is-inactive');
          panel.classList.remove('is-active');
        }
      });

      activeCategory = cat;

      if (activeFilter === 'wishlist') {
        activeFilter = 'all';
        var filterTabs = document.querySelectorAll('[data-le-filter]');
        filterTabs.forEach(function (t) { t.classList.remove('is-active'); });
        var allTab = document.querySelector('[data-le-filter="all"]');
        if (allTab) allTab.classList.add('is-active');
      }

      applyCardVisibility();
    }

    catBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchCategory(btn.getAttribute('data-le-cat-btn'));
      });
    });

    swBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchCategory(btn.getAttribute('data-le-sw-btn'));
      });
    });

    panels.forEach(function (panel) {
      panel.addEventListener('click', function () {
        switchCategory(panel.getAttribute('data-le-panel'));
      });
    });
  }

  /* ── WISHLIST ── */
  var LS_KEY = 'le_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list)); }
    catch (e) { /* quota exceeded */ }
  }

  function isWished(id) {
    return getWishlist().indexOf(id) !== -1;
  }

  function toggleWish(id) {
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) { list.push(id); } else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1;
  }

  function syncWishButtons() {
    document.querySelectorAll('[data-le-wish]').forEach(function (btn) {
      var id = btn.getAttribute('data-le-wish');
      var wished = isWished(id);
      btn.classList.toggle('is-wished', wished);
      btn.textContent = wished ? '♥' : '♡';
    });
  }

  function initWishlist() {
    syncWishButtons();

    document.querySelectorAll('[data-le-wish]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-le-wish');
        var nowWished = toggleWish(id);
        btn.classList.toggle('is-wished', nowWished);
        btn.textContent = nowWished ? '♥' : '♡';
        updateFilterCounts();
      });
    });
  }

  /* ── FILTER ── */
  var activeCategory = 'apple';
  var activeFilter = 'all';

  function updateFilterCounts() {
    var cards = document.querySelectorAll('[data-le-card-status]');
    var wishlist = getWishlist();
    var total = 0;
    var available = 0;
    var soldout = 0;
    var wished = 0;

    cards.forEach(function (card) {
      var matchCat = !activeCategory || card.getAttribute('data-le-card-category') === activeCategory;
      if (!matchCat) return;
      total++;
      var status = card.getAttribute('data-le-card-status');
      if (status === 'soldout') { soldout++; } else { available++; }
      var cardId = card.getAttribute('data-le-card-id');
      if (cardId && wishlist.indexOf(cardId) !== -1) wished++;
    });

    var allWished = 0;
    cards.forEach(function (card) {
      var cardId = card.getAttribute('data-le-card-id');
      if (cardId && wishlist.indexOf(cardId) !== -1) allWished++;
    });

    var pad = function (n) { return String(n).padStart(2, '0'); };
    var elAll = document.querySelector('[data-le-count-all]');
    var elAvail = document.querySelector('[data-le-count-available]');
    var elSold = document.querySelector('[data-le-count-soldout]');
    var elWish = document.querySelector('[data-le-wish-count]');
    if (elAll) elAll.textContent = pad(total);
    if (elAvail) elAvail.textContent = pad(available);
    if (elSold) elSold.textContent = pad(soldout);
    if (elWish) elWish.textContent = pad(allWished);
  }

  function applyCardVisibility() {
    var wishlist = getWishlist();
    var cards = document.querySelectorAll('[data-le-card-status]');
    var isWishlistFilter = activeFilter === 'wishlist';

    cards.forEach(function (card) {
      var matchFilter;
      if (isWishlistFilter) {
        var cardId = card.getAttribute('data-le-card-id');
        matchFilter = wishlist.indexOf(cardId) !== -1;
      } else {
        var matchCat = !activeCategory || card.getAttribute('data-le-card-category') === activeCategory;
        matchFilter = matchCat && (activeFilter === 'all' || card.getAttribute('data-le-card-status') === activeFilter);
      }
      card.style.display = matchFilter ? 'flex' : 'none';
    });

    var catBtns = document.querySelectorAll('[data-le-cat-btn]');
    var swBtns = document.querySelectorAll('[data-le-sw-btn]');
    if (isWishlistFilter) {
      catBtns.forEach(function (btn) { btn.classList.remove('is-active'); });
      swBtns.forEach(function (btn) { btn.classList.remove('is-active'); });
    } else {
      catBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-le-cat-btn') === activeCategory);
      });
      swBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-le-sw-btn') === activeCategory);
      });
    }

    updateFilterCounts();
  }

  function initFilter() {
    var filterTabs = document.querySelectorAll('[data-le-filter]');

    filterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        filterTabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        activeFilter = tab.getAttribute('data-le-filter');
        applyCardVisibility();
      });
    });
  }

  /* ── IMAGE VIEWER ── */
  function initViewers() {
    var viewers = document.querySelectorAll('[data-le-viewer]');
    var labels = ['Bild 1', 'Bild 2', 'Bild 3'];

    viewers.forEach(function (viewer) {
      var slidesContainer = viewer.querySelector('.le-viewer__slides');
      var slides = viewer.querySelectorAll('.le-viewer__slide');
      var dots = viewer.querySelectorAll('.le-viewer__dot');
      var labelEl = viewer.querySelector('.le-viewer__label');
      var prevBtn = viewer.querySelector('.le-viewer__arrow--prev');
      var nextBtn = viewer.querySelector('.le-viewer__arrow--next');
      var current = 0;
      var total = slides.length;

      if (total === 0) return;

      var slideLabels = [];
      slides.forEach(function (slide) {
        slideLabels.push(slide.getAttribute('data-le-slide-label') || '');
      });

      function update(idx) {
        current = ((idx % total) + total) % total;
        if (slidesContainer) {
          slidesContainer.style.transform = 'translateX(-' + (current * 100) + '%)';
        }
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
        });
        if (labelEl && slideLabels[current]) {
          labelEl.textContent = slideLabels[current];
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          update(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          update(current + 1);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          update(i);
        });
      });

      /* Drag / swipe */
      var startX = 0;
      var dragging = false;

      viewer.addEventListener('mousedown', function (e) {
        startX = e.clientX;
        dragging = true;
        e.preventDefault();
      });

      viewer.addEventListener('mousemove', function () {
        /* tracking only */
      });

      viewer.addEventListener('mouseup', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 40) {
          dx < 0 ? update(current + 1) : update(current - 1);
        }
      });

      viewer.addEventListener('mouseleave', function () { dragging = false; });

      /* Touch */
      viewer.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      viewer.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          dx < 0 ? update(current + 1) : update(current - 1);
        }
      });
    });
  }

  /* ── ADD TO CART ── */
  function initAddToCart() {
    document.querySelectorAll('[data-le-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-le-add-to-cart');
        if (!variantId) return;

        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = '…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart error');
            return res.json();
          })
          .then(function () {
            btn.textContent = '✓ Hinzugefügt';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);

            window.dispatchEvent(new CustomEvent('cartupdated'));
          })
          .catch(function () {
            btn.textContent = 'Fehler';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          });
      });
    });
  }

  /* ── BACK IN STOCK (Klaviyo) ── */

  function tryKlaviyoBISFrame(variantId) {
    var bisFrame = document.getElementById('BIS_frame');
    if (!bisFrame) return false;

    bisFrame.style.display = 'block';
    bisFrame.onload = function () {
      try {
        var iframeDoc = bisFrame.contentDocument || bisFrame.contentWindow.document;
        var selectEl = iframeDoc.getElementById('variants');
        if (selectEl) {
          selectEl.value = variantId;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (err) { /* cross-origin */ }
    };
    return true;
  }

  function getKlaviyoCompanyId() {
    var modal = document.querySelector('[data-le-bis-modal]');
    var fromSetting = modal ? modal.getAttribute('data-le-bis-company') : '';
    if (fromSetting) return fromSetting;

    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var m = scripts[i].src.match(/company_id=([A-Za-z0-9]+)/);
      if (m) return m[1];
    }
    return '';
  }

  function openBISModal(variantId, productName) {
    var modal = document.querySelector('[data-le-bis-modal]');
    if (!modal) return;

    var titleEl = modal.querySelector('[data-le-bis-modal-title]');
    var variantInput = modal.querySelector('[data-le-bis-variant-input]');
    var emailInput = modal.querySelector('[data-le-bis-email]');
    var statusEl = modal.querySelector('[data-le-bis-status]');
    var form = modal.querySelector('[data-le-bis-form]');

    if (titleEl) titleEl.textContent = productName || 'Benachrichtigung';
    if (variantInput) variantInput.value = variantId;
    if (emailInput) emailInput.value = '';
    if (statusEl) { statusEl.style.display = 'none'; statusEl.className = 'le-bis-modal__status'; }
    if (form) form.style.display = '';

    modal.style.display = 'flex';
  }

  function closeBISModal() {
    var modal = document.querySelector('[data-le-bis-modal]');
    if (modal) modal.style.display = 'none';
  }

  function initBIS() {
    document.querySelectorAll('[data-le-bis-variant]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-le-bis-variant');

        if (tryKlaviyoBISFrame(variantId)) return;

        openBISModal(variantId, btn.getAttribute('data-le-bis-product'));
      });
    });

    document.querySelectorAll('[data-le-bis-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeBISModal(); });
    });

    var form = document.querySelector('[data-le-bis-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var companyId = getKlaviyoCompanyId();
        var variantId = form.querySelector('[data-le-bis-variant-input]').value;
        var email = form.querySelector('[data-le-bis-email]').value;
        var submitBtn = form.querySelector('.le-bis-modal__submit');
        var statusEl = document.querySelector('[data-le-bis-status]');

        if (!companyId) {
          if (statusEl) {
            statusEl.textContent = 'Konfigurationsfehler: Klaviyo Company ID fehlt.';
            statusEl.className = 'le-bis-modal__status le-bis-modal__status--error';
            statusEl.style.display = '';
          }
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = '…';

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + variantId
                  }
                }
              }
            }
          })
        })
          .then(function (res) {
            if (!res.ok && res.status !== 202) throw new Error('API ' + res.status);
            form.style.display = 'none';
            if (statusEl) {
              statusEl.textContent = 'Fertig! Wir benachrichtigen dich, sobald das Produkt verfügbar ist.';
              statusEl.className = 'le-bis-modal__status le-bis-modal__status--success';
              statusEl.style.display = '';
            }
          })
          .catch(function () {
            if (statusEl) {
              statusEl.textContent = 'Leider ist ein Fehler aufgetreten. Bitte versuche es erneut.';
              statusEl.className = 'le-bis-modal__status le-bis-modal__status--error';
              statusEl.style.display = '';
            }
            submitBtn.disabled = false;
            submitBtn.textContent = 'Benachrichtige mich';
          });
      });
    }
  }

  /* ── SCROLL REVEAL ── */
  function initScrollReveal() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.le-reveal, .le-reveal-l, .le-reveal-r').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── INIT ── */
  function init() {
    initCountdown();
    initCategorySwitcher();
    initFilter();
    initWishlist();
    applyCardVisibility();
    initViewers();
    initAddToCart();
    initBIS();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
